// extracted by mini-css-extract-plugin
export default {"buttonSupport":"buttonSupport_buttonSupport__IrtsE"};